import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Dashboard from "./pages/Dashboard";
import Upload from "./pages/Upload";
import Result from "./pages/Result";
import PracticeTest from "./pages/PracticeTest";
import History from "./pages/History";
import Settings from "./pages/Settings";
import Admin from "./pages/Admin";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import Achievements from "./pages/Achievements";
import Parent from "./pages/Parent";
import { getRole } from "./lib/api";

const RequireRole = ({ role, children }) => {
  const token = localStorage.getItem("evodevi_token");
  if (!token) return <Navigate to="/login" replace />;
  const current = getRole();
  if (current !== role) return <Navigate to={current === "parent" ? "/parent" : "/app"} replace />;
  return children;
};

function App() {
  return (
    <div className="App">
      <Toaster position="top-center" richColors />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />

          {/* Student panel */}
          <Route path="/app" element={<RequireRole role="student"><Dashboard /></RequireRole>} />
          <Route path="/app/upload" element={<RequireRole role="student"><Upload /></RequireRole>} />
          <Route path="/app/result/:id" element={<RequireRole role="student"><Result /></RequireRole>} />
          <Route path="/app/test/:id" element={<RequireRole role="student"><PracticeTest /></RequireRole>} />
          <Route path="/app/history" element={<RequireRole role="student"><History /></RequireRole>} />
          <Route path="/app/settings" element={<RequireRole role="student"><Settings /></RequireRole>} />
          <Route path="/app/achievements" element={<RequireRole role="student"><Achievements /></RequireRole>} />

          {/* Parent panel */}
          <Route path="/parent" element={<RequireRole role="parent"><Parent /></RequireRole>} />
          <Route path="/parent/upload" element={<RequireRole role="parent"><Upload /></RequireRole>} />
          <Route path="/parent/result/:id" element={<RequireRole role="parent"><Result /></RequireRole>} />

          {/* Admin (parents only, backend also enforces admin flag) */}
          <Route path="/admin" element={<RequireRole role="parent"><Admin /></RequireRole>} />

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
